module.exports = __webpack_public_path__ + "media/video.895254db.mp4";